import Swiper from "swiper/swiper-bundle";

export default {
  init() {
    if (document.querySelector(".property-gallery-swiper")) {
      const small = new Swiper(".property-gallery-thumb-swiper", {
        spaceBetween: 8,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,

        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 4,
          },
          992: {
            spaceBetween: 10,
            slidesPerView: 5,
          },
          1200: {
            spaceBetween: 20,
            slidesPerView: 6,
          },
        },
      });

      const big = new Swiper(".property-gallery-swiper", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoHeight: true,
        thumbs: {
          swiper: small,
        },
      });
    }
  },
  finalize() { },
};
